import en from './en'
import ch from './zh_CN'
const messages = {
  en,
  ch
}

export default messages
